var _circle, _path, _path2, _path3, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfidSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 18,
    r: 1.8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13a5 5 0 0 1 5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9a9 9 0 0 1 9 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5a13 13 0 0 1 13 13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 30,
    textAnchor: "middle",
    textLength: 30,
    lengthAdjust: "spacingAndGlyphs",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "currentColor"
  }, "RFID")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfidSignal);
export default __webpack_public_path__ + "static/media/rfidSignal.5e18cf1ef3e684fc10430a0e01acc711.svg";
export { ForwardRef as ReactComponent };